import React from "react";

export default function SkeletonLoader({ rows = 3, form = false }) {
  // if (form) {
  //   return (
  //     <div className="space-y-4 animate-pulse p-4 border border-gray-200 rounded-lg shadow-sm">
  //       <div className="space-y-2">
  //         {/* Label and Input field skeleton */}
  //         <div className="h-4 bg-gray-300 rounded w-1/4"></div>
  //         <div className="h-8 bg-gray-300 rounded w-full"></div>
  //       </div>
  //       <div className="space-y-2">
  //         {/* Label and Textarea skeleton */}
  //         <div className="h-4 bg-gray-300 rounded w-1/3"></div>
  //         <div className="h-24 bg-gray-300 rounded w-full"></div>
  //       </div>
  //       <div className="space-y-2">
  //         {/* Label and Checkbox/Radio skeleton */}
  //         <div className="h-4 bg-gray-300 rounded w-1/5"></div>
  //         <div className="flex items-center space-x-2">
  //           <div className="h-4 w-4 bg-gray-300 rounded-full"></div>
  //           <div className="h-4 w-20 bg-gray-300 rounded"></div>
  //         </div>
  //       </div>
  //       {/* Button skeleton */}
  //       <div className="flex justify-end pt-2">
  //         <div className="h-10 w-24 bg-gray-300 rounded-md"></div>
  //       </div>
  //     </div>
  //   );
  // }

  // Original skeleton for rows
  return (
    // <div className="space-y-3 animate-pulse">
    //   {Array.from({ length: rows }).map((_, i) => (
    //     <div key={i} className="h-6 bg-gray-300 rounded w-full"></div>
    //   ))}
    // </div>
    //  <div className="space-y-4 animate-pulse p-4 border border-gray-200 rounded-lg shadow-sm">
    //     <div className="space-y-2">
    //       {/* Label and Input field skeleton */}
    //       <div className="h-4 bg-gray-300 rounded w-1/4"></div>
    //       <div className="h-8 bg-gray-300 rounded w-full"></div>
    //     </div>
    //     <div className="space-y-2">
    //       {/* Label and Textarea skeleton */}
    //       <div className="h-4 bg-gray-300 rounded w-1/3"></div>
    //       <div className="h-24 bg-gray-300 rounded w-full"></div>
    //     </div>
    //     <div className="space-y-2">
    //       {/* Label and Checkbox/Radio skeleton */}
    //       <div className="h-4 bg-gray-300 rounded w-1/5"></div>
    //       <div className="flex items-center space-x-2">
    //         <div className="h-4 w-4 bg-gray-300 rounded-full"></div>
    //         <div className="h-4 w-20 bg-gray-300 rounded"></div>
    //       </div>
    //     </div>
    //     {/* Button skeleton */}
    //     <div className="flex justify-end pt-2">
    //       <div className="h-10 w-24 bg-gray-300 rounded-md"></div>
    //     </div>
    //   </div>
       <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div className="spinner"></div>
        </div>
  );
}